'use client'

import { Loader2Icon } from 'lucide-react'

import { cn } from '@/_lib/utils'

/**
 * Shared layout/typography for the mobile empty state row and the mobile loading row under day pills.
 */
export const calendarSlotsAreaInlineRowClass =
	'flex min-h-[32px] items-center justify-center gap-2 text-center text-xs font-base text-medante-purple-dark/55'

type AProductTemplateCalendarLoadingProps = {
	className?: string
	/** `mobile`: compact row matching empty state height. `desktop`: taller centered block. */
	variant?: 'mobile' | 'desktop'
}

/**
 * Inline loading indicator for the expanded product template calendar (mobile or desktop density).
 *
 * @param props - Loading props.
 * @param props.className - Optional extra classes on the status container.
 * @param props.variant - Layout preset; defaults to `mobile`.
 */
export function AProductTemplateCalendarLoading({
	className,
	variant = 'mobile'
}: AProductTemplateCalendarLoadingProps) {
	const isDesktop = variant === 'desktop'

	return (
		<div
			className={cn(
				isDesktop
					? 'flex min-h-[265px] items-center justify-center gap-2.5 text-center text-sm font-base text-medante-purple-dark/55'
					: calendarSlotsAreaInlineRowClass,
				className
			)}
			role='status'
		>
			<Loader2Icon
				className={cn(
					'shrink-0 animate-spin text-current',
					isDesktop ? 'size-4' : 'h-[1em] w-[1em]'
				)}
				aria-hidden
			/>
			<span>Načítavame voľné termíny…</span>
		</div>
	)
}
